import Vue from "vue"
import _ from "lodash"
import Cookies from "js-cookie"
import { isCartPage } from "@/utils/utils"
// ;(async function () {
let deviceWidth
let top
let wellcome
let webTips
// 初始化设置缩放
setHtmlFontSize()
if (window.addEventListener) {
  window.addEventListener("load", function () {
    // header 适配
    top = document.getElementById("top-box-wrapper")
    wellcome = document.getElementById("wellcome-bg-wrapper")
    webTips = document.getElementById("webTips")
  })
  window.addEventListener("resize", setHtmlFontSize, false)
  window.addEventListener("scroll", _.throttle(handleScroll, 100), false)
}

function throttle(fn, wait) {
  let previous = 0
  return function (...args) {
    const now = +new Date()
    if (now - previous >= wait) {
      fn.apply(this, args)
      previous = now
    }
  }
}
function setHtmlFontSize() {
  // 1360是设计稿的宽度，大于1360宽度为1360，小于1100宽度为1100
  deviceWidth = document.documentElement.clientWidth >= 1360 ? 1360 : document.documentElement.clientWidth
  const scale = parseFloat(deviceWidth / 1360)
  document.documentElement.style.fontSize = scale * 100 + "px"
  document.documentElement.style.setProperty("--zoom-level", scale)
}

function handleScroll() {
  const scrollT = document.documentElement.scrollTop || document.body.scrollTop
  const topbox = document.getElementById("top-wrapper")
  const topContent = document.getElementById("top-content-wrapper")
  const searchWrapper = document.getElementById("search-wrapper")
  // const addressWrapper = document.getElementById("address-wrapper")
  const wellcome = document.getElementById("wellcome-bg-wrapper")
  const categoryCascader = document.getElementById("category-cascader")
  const webTips = document.getElementById("webTips")
  if (scrollT > 200) {
    Vue.prototype.$bus && Vue.prototype.$bus.$emit("setShortenHeader", true)
    if (topbox) {
      topbox.style.height = 0
      topbox.style.padding = 0
      topbox.style.overflow = "hidden"
    }
    if (topContent) {
      topContent.style.height = isCartPage() ? "0.84rem" : "1.21rem"
    }
    if (searchWrapper) {
      searchWrapper.style.paddingTop = "0.12rem"
    }
    // if (addressWrapper) {
    //   addressWrapper.style.height = 0
    //   addressWrapper.style.paddingTop = 0
    //   addressWrapper.style.overflow = "hidden"
    // }
    if (wellcome) {
      wellcome.style.height = "0.46rem"
      wellcome.style.top = "0.75rem"
    }
    if (categoryCascader) {
      categoryCascader.style.top = "0.41rem"
    }
    if (webTips) {
      webTips.style.height = 0
      webTips.style.paddingTop = 0
      webTips.style.paddingBottom = 0
      webTips.style.overflow = "hidden"
    }
  } else {
    Vue.prototype.$bus && Vue.prototype.$bus.$emit("setShortenHeader", false)
    if (topbox) {
      topbox.style.height = "unset"
      topbox.style.paddingTop = "0.1rem"
      topbox.style.overflow = "unset"
    }
    if (topContent) {
      topContent.style.height = isCartPage() ? "1.16rem" : "1.57rem"
    }
    if (searchWrapper) {
      searchWrapper.style.paddingTop = "0.1rem"
    }
    // if (addressWrapper) {
    //   addressWrapper.style.height = "unset"
    //   addressWrapper.style.paddingTop = "0.2rem"
    //   addressWrapper.style.overflow = "unset"
    // }
    if (wellcome) {
      wellcome.style.height = "0.58rem"
      webTips ? (wellcome.style.top = "1.72rem") : (wellcome.style.top = "1.12rem")
    }

    if (categoryCascader) {
      categoryCascader.style.top = "0.56rem"
    }
    if (webTips) {
      webTips.style.height = "0.6rem"
      webTips.style.top = "0"
      webTips.style.padding = "0.12rem"
    }
  }
}
// })()
